import { render, staticRenderFns } from "./OldDashboard.vue?vue&type=template&id=c2e55f30&scoped=true&"
import script from "./OldDashboard.vue?vue&type=script&lang=ts&"
export * from "./OldDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./OldDashboard.vue?vue&type=style&index=0&id=c2e55f30&prod&lang=scss&"
import style1 from "./OldDashboard.vue?vue&type=style&index=1&id=c2e55f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e55f30",
  null
  
)

export default component.exports